import * as React from 'react';

import { KitItem } from '../generated/graphql';

import { getKitIconBackgroundStyle } from '../pages/Match/utils';

interface Props {
  kitItems: Pick<KitItem, 'id' | 'name'>[];
  size?: 'sm' | 'md';
}

export const KitList = ({ kitItems: chosenKitItems, size = 'md' }: Props) => {
  const sizeClassNames = size === 'sm' ? 'w-6 h-6' : 'w-8 h-8';

  return (
    <ul className="my-1">
      {chosenKitItems.map((item) => {
        return (
          <li key={item.id} className="flex items-center py-1">
            <div
              className={`${sizeClassNames} mr-2 rounded-full shadow flex-shrink-0`}
              style={{ background: getKitIconBackgroundStyle(item.name) }}
            />
            <p>{item.name}</p>
          </li>
        );
      })}
    </ul>
  );
};
